export const MenuItems = [
    {
        title: 'About',
        id: "aboutme",
        url: '#',
    },
    {
        title: 'Experience',
        id: "experience",
        url: '#',
    },
    {
        title: 'Projects',
        id: 'projects',
        url: '#',
    },
    {
        title: 'Achievements',
        id: 'achievements',
        url: '#',
    },
    // {
    //     title: 'Blogs',
    //     id: 'blogsPub',
    //     url: '#',
    // },
]
